import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/use-network-status";

export function OfflineBanner() {
    const isOnline = useNetworkStatus();

    if (isOnline) return null;

    return (
        <div className="w-full bg-amber-500/10 border-b border-amber-500/20 backdrop-blur-md animate-in slide-in-from-top duration-300">
            <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-amber-600 dark:text-amber-400 text-xs font-medium">
                <WifiOff className="h-3.5 w-3.5" />
                <span>Sin conexión. Estás trabajando en modo local. Los cambios se sincronizarán al volver online.</span>
            </div>
        </div>
    );
}
